  function planetId2ArrayId (signID) {
    // console.log('pId in', signID)
    let planetArrayId;
    switch (signID) {
      case "1":
          planetArrayId="4";
        return planetArrayId;
        // break;
      case "2":
          planetArrayId="2";
        return planetArrayId;
        // break;

      case "3":
          planetArrayId="1";
        return planetArrayId;
        // break;

      case "4":
          planetArrayId="3";
        return planetArrayId;

        // break;
      case "5":
          planetArrayId="0";
        return planetArrayId;

        // break;
      case "6":
          planetArrayId="1";
        return planetArrayId;

        // break;
      case "7":
          planetArrayId="2";
        return planetArrayId;

        // break;
      case "8":
          planetArrayId="9";
        return planetArrayId;

        // break;
      case "9":
          planetArrayId="5";
        return planetArrayId;

        // break;
      case "10":
          planetArrayId="6";
        return planetArrayId;

        // break;
      case "11":
          planetArrayId="7";
        return planetArrayId;

        // break;
      case "12":
          planetArrayId="8";
        return planetArrayId;

        // break;

        // break;

      case 1:
          planetArrayId="4";
        return planetArrayId;
        // break;

      case 2:
          planetArrayId="2";
        return planetArrayId;
        // break;

      case 3:
          planetArrayId="1";
        return planetArrayId;
        // break;

      case 4:
          planetArrayId="3";
        return planetArrayId;

        // break;
      case 5:
          planetArrayId="0";
        return planetArrayId;

        // break;
      case 6:
          planetArrayId="1";
        return planetArrayId;

        // break;
      case 7:
          planetArrayId="2";
        return planetArrayId;

        // break;
      case 8:
          planetArrayId="9";
        return planetArrayId;

        // break;
      case 9:
          planetArrayId="5";
        return planetArrayId;

        // break;
      case 10:
          planetArrayId="6";
        return planetArrayId;

        // break;
      case 11:
          planetArrayId="7";
        return planetArrayId;

        // break;
      case 12:
          planetArrayId="8";
        return planetArrayId;

        // break;

      default:
          
        return undefined;
        // break;
    }
  }
  export { planetId2ArrayId };